import { CSSProperties } from "react";

const QuoteSVG = ({ color = "#1C3039", style }: { color?: string; style?: CSSProperties }) => {
    return (
        <div style={style}>
            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    id="&#226;&#128;&#156;"
                    d="M15 9.23077C15 7.47692 13.6893 6.41538 12.0874 6.41538C11.6019 6.41538 11.2621 6.55385 11.1165 6.64615C11.165 4.75385 12.6213 2.63077 14.7573 2.16923V0C12.0388 0.276922 8.30097 2.63077 8.30097 8.07692C8.30097 10.7077 9.95145 12 11.8447 12C13.6408 12 15 10.7538 15 9.23077ZM6.69902 9.23077C6.69902 7.47692 5.38834 6.41538 3.7864 6.41538C3.30096 6.41538 2.96116 6.55385 2.81552 6.64615C2.86407 4.75385 4.32038 2.63077 6.4563 2.16923V0C3.73785 0.276922 0 2.63077 0 8.07692C0 10.7077 1.65048 12 3.54369 12C5.3398 12 6.69902 10.7538 6.69902 9.23077Z"
                    fill={color}
                />
            </svg>
        </div>
    );
};

export default QuoteSVG;
